module.exports = __webpack_public_path__ + "media/images/pic/labels/b2_1-a2ef957bddbec4fc2400877bc2a2c76d.png";